import { Pipe, PipeTransform } from '@angular/core';
import { getNestedObjectValuesByString } from '../helper';

@Pipe({
  standalone: true,
  name: 'getNestedObjectValuesByString',
})
export class GetNestedObjectValuesByString<T extends object> implements PipeTransform {
  transform(source: T, keysString: string): unknown {
    return getNestedObjectValuesByString(source, keysString);
  }
}
